(() => {
  angular
    .module('gm.common.filters')
    .filter('gmRound', gmRoundFilter);

  function gmRoundFilter() {
    'ngInject';

    return (val, precision = 2) => {
      // eslint-disable-next-line no-restricted-properties
      const i = Math.pow(10, precision);

      return Math.round(val * i) / i;
    };
  }
})();
